export type ResponsiveBreakpoints = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export enum ResponsiveBreakpoint {
  SM = 'sm',
  MD = 'md',
  LG = 'LG',
  XL = 'xl',
  XXL = 'xxl',
}
export const BREAKPOINTS = ['sm', 'md', 'lg', 'xl', 'xxl'];
